export const MCASSET_VERSION = '20w17a'
export const BASE_FONT = "minecraft:default";
export const DEFAULT_PREVIEW_SCALE = 4
